/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var ArrowCollapseCHOpenIcon64Regular = forwardRef('ArrowCollapseCHOpenIcon64Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 64 }, props),
        React.createElement("path", { d: "M5.182 37.303a7.5 7.5 0 0 1 0-10.606l16.257-16.258a1.5 1.5 0 0 1 2.121 2.122L7.303 28.818a4.5 4.5 0 0 0 0 6.364L23.56 51.44a1.5 1.5 0 1 1-2.121 2.12L5.182 37.304Z" }),
        React.createElement("path", { d: "M58.818 37.303a7.5 7.5 0 0 0 0-10.606L42.561 10.439a1.5 1.5 0 0 0-2.122 2.122l16.258 16.257a4.5 4.5 0 0 1 0 6.364L40.439 51.44a1.5 1.5 0 1 0 2.122 2.12l16.257-16.257Z" })));
});
